import { GatsbyImage, getImage } from "gatsby-plugin-image"

export const Img = ({
  image,
  alt,
  className,
  imgClassName,
  style,
  imgStyle,
  ...rest
}) => {
  if (image === undefined) return null

  const altText = alt || image?.altTag

  if ("localFile" in image && image.extension !== "svg") {
    return (
      image.localFile && (
        <GatsbyImage
          alt={altText ?? ""}
          className={className}
          loading="eager"
          image={getImage(image.localFile)}
          imgClassName={imgClassName}
          style={style}
          imgStyle={imgStyle}
        />
      )
    )
  }

  const defaultImgClass =
    "absolute inset-0 object-cover w-full h-full p-0 max-w-none"

  const { width, height } = image

  const aspectRatio = width ? (height / width) * 100 : false

  return (
    image?.url && (
      <div
        className={className}
        style={{ position: "relative", overflow: "hidden", ...style }}
        {...rest}
      >
        {aspectRatio && (
          <div
            aria-hidden="true"
            style={{
              paddingTop: `${aspectRatio}%`,
              maxWidth: "100%",
              maxHeight: "100%",
            }}
          />
        )}
        <picture>
          <img
            alt={altText}
            src={image.url}
            width={1}
            height={aspectRatio && `${aspectRatio}%`}
            decoding="async"
            loading="eager"
            className={imgClassName ?? defaultImgClass}
            style={{ ...imgStyle }}
          />
        </picture>
      </div>
    )
  )
}
